// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let DisplayNeighborhoodInputRelay = require("../DisplayNeighborhoodInputRelay.bs.js");

function areaToOpt(id, label) {
  return {
    id: id,
    name: label
  };
}

function inputPlaceholder(hasValue, geocodingStatus) {
  if (hasValue) {
    return;
  }
  switch (geocodingStatus) {
    case "NotCalled" :
      return "Missing address. Please check Key Facts...";
    case "Called" :
      return "Loading display neighborhoods...";
    case "Valid" :
      return;
    default:
      return "Error validating the address. Please check Key Facts...";
  }
}

function inputDisabled(hasValue, geocodingStatus) {
  if (hasValue) {
    return false;
  } else {
    return geocodingStatus !== "Valid";
  }
}

function WizardDisplayNeighborhoodField(props) {
  let geocodingStatus = props.geocodingStatus;
  let displayNeighborhoods = props.displayNeighborhoods;
  let displayNeighborhood = props.displayNeighborhood;
  let match = displayNeighborhood.value;
  let areas;
  let exit = 0;
  if (displayNeighborhoods.length !== 0 || match === undefined) {
    exit = 1;
  } else {
    areas = [{
        id: match.id,
        name: match.label
      }];
  }
  if (exit === 1) {
    areas = displayNeighborhoods.map(dn => ({
      id: dn.id,
      name: dn.label
    }));
  }
  let match$1 = displayNeighborhood.value;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 12,
    children: [
      JsxRuntime.jsx(DisplayNeighborhoodInputRelay.make, {
        areas: areas,
        placeholder: inputPlaceholder(displayNeighborhood.value !== undefined, geocodingStatus),
        helpText: props.helpText,
        isDisabled: inputDisabled(displayNeighborhood.value !== undefined, geocodingStatus),
        onChange: value => displayNeighborhood.onChange(value !== undefined ? ({
            id: value.id,
            label: value.name
          }) : undefined),
        onBlur: param => displayNeighborhood.onBlur(),
        status: displayNeighborhood.status,
        value: match$1 !== undefined ? ({
            id: match$1.id,
            name: match$1.label
          }) : undefined
      }),
      JsxRuntime.jsx(Form__Components.FieldError.make, {
        valid: displayNeighborhood.valid
      })
    ]
  });
}

let FormUtils;

let make = WizardDisplayNeighborhoodField;

exports.FormUtils = FormUtils;
exports.areaToOpt = areaToOpt;
exports.inputPlaceholder = inputPlaceholder;
exports.inputDisabled = inputDisabled;
exports.make = make;
/* Form__Components Not a pure module */
